/*
 * @Descripttion:
 * @version:
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2026-01-27 13:17:22
 */
export const CURRENT_CONFIG = {
  // license
  appId: "128254", // You need to go to the development website to apply.
  appKey: "7d1ca7e7c5de707426d5d4f5d28030a", // You need to go to the development website to apply.
  appLicense:
    "TROvL+uAHaqzumT2yPGhwKKapD2hlWW6xCOXxbIC/S7S5dVvw3+UxGAeLzN1ZZkE0OLTEq1hTNJ0MkIdkqxSIO1/j/A0dwEMqkfHdn9sBuDNS6JGHwokzlHJEZCEuUO9jVWoEXo0bSelm8hp21mzSqcAyVxVg2S9Zum1qMG8Pkg=", // You need to go to the development website to apply.

  // http 内网穿透到本地132.232.53.29 线上1.14.163.252 192.168.2.10
  // baseURL: 'http://1.14.163.252:8085/', //
  // websocketURL: 'ws://1.14.163.252:8085/api/v1/ws',
  // 线上
  baseURL: "https://fly.cdjjhb.cn:8085/", //
  websocketURL: "wss://fly.cdjjhb.cn:8085/api/v1/ws",
  // baseURL: "http://125.70.13.132:8086/backstage/", // 科尔沁
  // websocketURL: "ws://125.70.13.132:8086/backstage/api/v1/ws", // 科尔沁
  // baseURL: "http://223.86.29.68:27017/backstage/", // 广汉
  // websocketURL: "ws://223.86.29.68:27017/backstage/api/v1/ws", // 广汉
  // baseURL: "http://183.222.76.133:8086/backstage/", // 资中
  // websocketURL: "ws://183.222.76.133:8086/backstage/api/v1/ws", // 资中

  // 本地
  // baseURL: "http://192.168.1.5:8085/", //
  // websocketURL: "ws://192.168.1.5:8085/api/v1/ws",
  // baseURL: 'http://112.19.171.189:8085/', //
  // websocketURL: 'ws://112.19.171.189:8085/api/v1/ws',
  // 代理地址
  // quanUrl: 'http://112.19.171.189:8666',
  // quanUrl: "http://125.70.13.132:8086/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 科尔沁
  // quanUrl: "http://223.86.29.68:27017/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 广汉
  // quanUrl: "http://183.222.76.133:8086/backstage/minioFile", // 文件下载 与baseUrl保持一致 // 资中
  quanUrl: "https://fly.cdjjhb.cn:8085/minioFile", // 文件下载 与baseUrl保持一致
  // quanUrl: 'http://192.168.1.15:8085/minioFile',
  // 文件服务 key
  // bucket: 'yd-bucket',
  bucket: "ga-bucket",
  // bucket: 'fly-bucket',
  // aiBaseUrl: "http://125.70.13.132:8086/", // 后端ai项目 科尔沁
  // aiBaseUrl: "http://223.86.29.68:27017/", // 后端ai项目 广汉
  // aiBaseUrl: "http://183.222.76.133:8086/", // 后端ai项目 资中
  aiBaseUrl: "https://fly.cdjjhb.cn/", // 后端ai项目
  // aiBaseUrl: "/aiBaseUrl", // 本地测试
  // dbBaseUrl: "/dbBaseUrl", // 后台 db 地址
  dbBaseUrl: "https://fly.cdjjhb.cn/zbt/", // 后台 db 地址
  // dbBaseUrl: "http://183.222.76.133:8086/zbt/", // 后台 db 地址 资中
  // dbBaseUrl: "http://223.86.29.68:27017/zbt/", // 后台 db 地址 广汉
  // dbBaseUrl: "http://125.70.13.132:8086/zbt/", // 后台 db 地址 科尔沁
  // 首页名称
  name: "瑞特无人机管控平台", //fly
  // name: "天枢航控低空运营服务平台", // 广汉
  reportBaseUrl: "https://zk.cdrzwx.cn/", // 报告地址
  vedioPrefix: "http://ga.cdrzwx.cn:9003/ga-bucket/", //生成任务时 视频地址 前缀
  // go2rtc ai视频播放
  // webRtcStreamerUrL: "http://183.222.76.133:1974", // go2rtc 地址，用于播放rtsp视频 资中
  // webRtcStreamerUrL: "http://223.86.29.68:27017", // go2rtc 地址，用于播放rtsp视频 广汉
  // webRtcStreamerUrL: "http://125.70.13.132:8086", // go2rtc 地址，用于播放rtsp视频 科尔沁
  webRtcStreamerUrL: "https://fly.cdjjhb.cn", // go2rtc 地址，用于播放rtsp视频 fly

  // webRtcStreamerWs: "api/ws?src=", // go2rtc 地址，用于连接 websocket https需要 go2rtc/，http则去掉 资中、科尔沁
  webRtcStreamerWs: "go2rtc/api/ws?src=", // go2rtc 地址，用于连接 websocket https需要 go2rtc/，http则去掉 广汉、fly
  // name: '无人机管控平台',
  layout: {
    driveFlyFlag: true, //御4 飞行页面 true为显示 false不显示
    statusJob: "0", // 任务管理-排序 排序 0:未执行；1已执行 科尔沁设置为0，其余设置为1
    pushFlag: false, // 广汉推送，广汉设置为 true，其余设置为 false
  },
  iframeUrl:
    "https://cloud.hfuav.com/#/Implant/correspondentLogin.html?userName=18283837113&key=3FZHKtp1CKYYBMPfuzyS&&sign=0ea16d1f5c4eeab5d31500495138c617&type=1", // iframe地址

  // livestreaming   rtmp://你电脑的 ip 地址/live   rtmp://1.14.163.252:1935/rtc/v1/play/
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  // rtmpURL: 'rtmp://192.168.1.100/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  rtmpURL: "rtmp://117.174.109.131/live/", // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://ga.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://rt.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // rtmpURL: 'rtmp://yd.cdrzwx.cn/live/', // Example: 'rtmp://139.186.165.236/live/'  1.14.163.252  113.141.88.164
  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: "132.232.53.29", // 服务器IP
  gbServerPort: "5060", // 服务器端口
  gbServerId: "44010200492000000001", // 服务器ID
  gbAgentId: "admin1", // 客户帐号
  gbPassword: "123456", // 密码
  gbAgentPort: "5060", // 本地端口
  gbAgentChannel: "34020000001320000100", // 通道号
  // RTSP
  rtspUserName: "admin",
  rtspPassword: "admin123",
  rtspPort: "554",
  // Agora
  agoraAPPID: "Please enter the agora app id.",
  agoraToken: "Please enter the agora temporary token.",
  agoraChannel: "Please enter the agora channel.",
  // map
  // You can apply on the AMap website. 80318ebe8ce042d5fdb5cebd7ff52acc
  amapKey: "ae8cd277a7d81c74b92cdea8bb2ba712", //高德地图key
  // amapKey: '80318ebe8ce042d5fdb5cebd7ff52acc', //高德地图key

  // 语音功能配置
  voice: {
    /** 是否启用语音唤醒功能 */
    enableVoiceWake: false,
    /** 是否启用语音对话功能 */
    enableVoiceDialogue: false,
    /** 默认唤醒词 */
    defaultWakeWord: "同学",
    /** 默认录音时长（毫秒） */
    defaultRecordDuration: 3000,
    /** 音量阈值 */
    volumeThreshold: 40,
    /** 静音时长（毫秒） */
    silenceDuration: 2000,
    /** 请求超时时间（毫秒） */
    requestTimeout: 20000,
    /** 最小音频大小（字节） */
    minAudioSize: 5000,
  },
};
